module.exports = __webpack_public_path__ + "img/editcar.3e99bc74.webp";